export const FLUSH_SOCIAL_ACT_STATE = 'socialAct/FLUSH_SOCIAL_ACT_STATE';
export const SELECT_CONTACT = 'socialAct/SELECT_CONTACT';